module.exports = __webpack_public_path__ + "static/media/step_over.373b0751.png";